import { Link } from "react-router-dom";
import { navLinks, siteInfo } from "@/mocks/site";

export default function SiteFooter() {
  return (
    <footer className="mt-auto w-full border-t border-background-200 bg-secondary-100">
      <div className="w-full px-4 py-10 md:px-6 md:py-14 lg:px-10">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4 lg:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-base font-bold text-background-50">
                五
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                {siteInfo.name}
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              {siteInfo.tagline}。我们把关于 511 爆料 的碎片信息重新排列，逐条标注来源与可信度，让每条说法都能追到出处。
            </p>
            <p className="mt-4 text-xs text-foreground-500">
              档案最近更新：{siteInfo.updatedAt}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">
              <Link to="/" className="transition-colors hover:text-primary-700">
                站内导航
              </Link>
            </h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {navLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">
              <Link to="/about" className="transition-colors hover:text-primary-700">
                联系与投稿
              </Link>
            </h4>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm text-foreground-600">
              <li className="flex items-start gap-2">
                <span className="mt-0.5 flex h-4 w-4 items-center justify-center">
                  <i className="ri-mail-line text-base"></i>
                </span>
                <a
                  href={`mailto:${siteInfo.email}`}
                  className="break-all transition-colors hover:text-primary-700"
                >
                  {siteInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-0.5 flex h-4 w-4 items-center justify-center">
                  <i className="ri-shield-check-line text-base"></i>
                </span>
                <span>所有线索都会标注来源等级</span>
              </li>
              <li>
                <Link
                  to="/faq"
                  className="inline-flex items-center gap-1 whitespace-nowrap text-primary-700 hover:text-primary-600"
                >
                  查看求证说明
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className="ri-arrow-right-line text-base"></i>
                  </span>
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-2 border-t border-secondary-200 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 {siteInfo.name} · 仅作公开信息整理与来源标注</p>
          <p>本站内容不构成事实定论，请结合原始材料独立判断</p>
        </div>
      </div>
    </footer>
  );
}